module.exports = __webpack_public_path__ + "static/media/chat-header.e10e2409.svg";